export default __webpack_public_path__ + "static/media/damodra.8ddec48a.png";